export const EDIT_PROFILE = "EDIT_PROFILE"
export const EDIT_PROFILE_SUCCESS="EDIT_PROFILE_SUCCESS"
export const EDIT_PROFILE_FAILED="EDIT_PROFILE_FAILED"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";
export const GET_PROFILE_DETAIL ="GET_PROFILE_DETAIL";
export const GET_PROFILE_DETAIL_SUCCESS ="GET_PROFILE_DETAIL_SUCCESS";
//get countries
export const GET_COUNTRIES ="GET_COUNTRIES";
export const GET_COUNTRIES_SUCCESS ="GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILED ="GET_COUNTRIES_FAILED";
//get state
export const GET_STATE ="GET_STATE";
export const GET_STATE2 ="GET_STATE2";
export const GET_STATE_SUCCESS ="GET_STATE_SUCCESS";
export const GET_STATE_FAILED ="GET_STATE_FAILED";

//vadidate url 

export const VALIDATE_URL="VALIDATE_URL"
export const VALIDATE_URL_SUCCESS="VALIDATE_URL_SUCCESS"
export const VALIDATE_URL_FAILED="VALIDATE_URL_FAILED"

export const ACCOUNT_SWITCH="ACCOUNT_SWITCH"
export const ACCOUNT_SWITCH_SUCCESS="ACCOUNT_SWITCH_SUCCESS"
export const ACCOUNT_SWITCH_FAILED="ACCOUNT_SWITCH_FAILED"
export const ACCOUNT_SWITCH_CLEAR="ACCOUNT_CLEAR"



